export class StartConversationRequest {
  constructor(
    public conversationName: string,
    public recipientUserId: string
  ) {}
}
